export default "__VITE_ASSET__3def7ec4__"